import { type StateCreator } from 'zustand';

export type SelectAllSlice = {
  selectAll: boolean;
  setSelectAll: (boardId: string | undefined) => void;
  resetSelectAll: () => void;
  includeNestedItems: boolean;
  setIncludeNestedItems: (includeNestedItems: boolean) => void;
  selectAllRootBoardId: string | undefined;
};

export type CreateSelectAllSlice = (
  initialState: Pick<Partial<SelectAllSlice>, 'selectAll' | 'includeNestedItems'>,
) => StateCreator<SelectAllSlice, [], [], SelectAllSlice>;

export const createSelectAllSlice: CreateSelectAllSlice = (initialState) => (set) => ({
  selectAll: initialState.selectAll ?? false,
  setSelectAll: (boardId) =>
    set({
      selectAll: true,
      selectAllRootBoardId: boardId,
      includeNestedItems: false,
    }),
  resetSelectAll: () =>
    set({
      selectAll: initialState.selectAll ?? false,
      includeNestedItems: initialState.includeNestedItems ?? false,
      selectAllRootBoardId: undefined,
    }),
  includeNestedItems: initialState.includeNestedItems ?? false,
  setIncludeNestedItems: (includeNestedItems) => set({ includeNestedItems }),
  selectAllRootBoardId: undefined,
});
